import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "pane"]

  switch(event) {
    const selected = event.currentTarget.dataset.tab

    this.tabTargets.forEach(t => t.classList.toggle("active", t.dataset.tab === selected))
    this.paneTargets.forEach(p => p.classList.toggle("active", p.dataset.pane === selected))
  }
}
